import React, { Component } from "react";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import history from "../../login/history";
import ConfigService from "../../../../services/configuracion/ConfigService";
import Loader from 'react-loader-spinner';
export default class Paso3 extends Component {

  constructor(props) {
    super(props);
    this.getInitialState = this.getInitialState.bind(this);
    this.state = this.getInitialState();
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getInitialState = () => ({
    buscando:false
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    this.initData();
    // sessionStorage.removeItem('PASO2');
  }
  initData = () => {
    this.getInitialState();
  };    

    
  confirmarBtn = () => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");  
    trackPromise(
      this.transferir().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);        
        if (jData.codigoRetorno === "0") {
                this.btn.removeAttribute("disabled");
                this.props.returnDataPaso2(jData.numeroOperacion);
                this.nextStep.click();
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      })
    ).catch(function (error) {
      //// Habilita boton
      this.btn.removeAttribute("disabled");
    });
  };

  home = (e) => {
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }

  render() {

    if( this.props.currentStep !== 3 ){
      return null
    }

    if( this.state.buscando ){
      return (<Loader type="TailSpin" color="#007c34" height="100" width="100" />);
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
          {
                sessionStorage.getItem('ACTION') === 'CREAR' ?
                (
                  <ul role="tablist">
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">                
                          <span className="title_text">Nuevo Pin</span>
                        </div>
                      </span>
                    </li>

                    <li role="tab" className="current last">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                )
                :
                (
                    <ul role="tablist">
                      <li role="tab" className="disabled">
                        <span>
                          <div className="title">                
                            <span className="title_text">Pin Actual</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="disabled">
                        <span>
                          <div className="title">
                            <span className="title_text">Nuevo Pin</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="current last">
                        <span>
                          <div className="title">
                            <span className="title_text">Confirmación</span>
                          </div>
                        </span>
                      </li>
                    </ul>
                )
              }
          </div>
        </div>

      

        <section className="content">
          <h4 style={{color: '#1A9185', margin:"1rem"}}>Confirmación Exitosa</h4>
          <div className="row" style={{display:'flex','justify-content':'center'}}>
            {
              localStorage.getItem('theme') === 'dark' ? 
              (
                <img alt="foto de confirmacion" src="dist/img/exito-dark.png" width='150rem' height='150rem'></img>
              )
              :
              (
                <img alt="foto de confirmacion" src="dist/img/exito-light.png" width='150rem' height='150rem'></img>
              )
            }
          </div>
          <div className="row" style={{display:'flex','justify-content':'center'}}>
            <div className="callout mensajes">
              <p>¡Se ha cambiado exitosamente el PIN de su tarjeta de crédito!</p>
            </div>
          </div>
        </section>

        <hr/>  
        
        <div className="row">
        
        <div className="col-md-12 btn-consulta">
          <button 
            className="btn btn-cu-secundary" 
            onClick={this.home}
          >
              <FontAwesomeIcon icon={faArrowLeft} /> Volver al Inicio
          </button>
        </div>  
        </div>
      </div>
    );
  }
}
